import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from './constants';
import HeaderAuth from './HeaderAuth';

const DesktopNavigation = ({ isLandingPage, currentUser, onLogout, isLoggingOut, onLoginClick }) => {
  const location = useLocation();

  return (
    <nav className="nav-menu desktop-nav">
      <Link
        to={ROUTES.ABOUT}
        className={`header-text ${!isLandingPage ? 'header-text-dark' : ''} ${
          location.pathname === ROUTES.ABOUT ? 'active' : ''
        }`}
      >
        About Us
      </Link>

      <HeaderAuth
        isLandingPage={isLandingPage}
        currentUser={currentUser}
        onLogout={onLogout}
        isLoggingOut={isLoggingOut}
        onLoginClick={onLoginClick}
      />
    </nav>
  );
};

export default DesktopNavigation;

